export default __webpack_public_path__ + "images/286605775329fe8345609476b041ddc5.png";